import { render, staticRenderFns } from "./TreePage.vue?vue&type=template&id=2abdce29&scoped=true"
import script from "./TreePage.vue?vue&type=script&lang=js"
export * from "./TreePage.vue?vue&type=script&lang=js"
import style0 from "./TreePage.vue?vue&type=style&index=0&id=2abdce29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdce29",
  null
  
)

export default component.exports